import React, { type JSX } from 'react'
import styled from '@emotion/styled'
import { Icon } from '@mobi/component-library/Legacy/Icon'
import { hexColors } from '@mobi/settings/hexColors'
import { ExpandablePanel } from '@core/Components/ExpandablePanel'

export const Disclaimers = ({ disclaimers }: { disclaimers: string[] }): JSX.Element | null => {
  const [isExpanded, setIsExpanded] = React.useState(false)
  if (typeof disclaimers === 'undefined' || disclaimers?.length <= 0) return null

  return (
    <div style={{ marginTop: '1rem', backgroundColor: hexColors.white }}>
      <ExpandablePanel
        scrollIntoViewWhenOpened={true}
        title='Betting Information - Tote'
        rightIcon={<Icon type='infoInvert' color={hexColors.summerSky} />}
        data-tid-tote-sport-pool-disclaimers
        headerClicked={() => setIsExpanded(!isExpanded)}
        expanded={isExpanded}
      >
        <DisclaimerContainerStyled>
          {disclaimers.map((disclaimer, index) => (
            <DisclaimerStyled key={index}>{disclaimer}</DisclaimerStyled>
          ))}
        </DisclaimerContainerStyled>
      </ExpandablePanel>
    </div>
  )
}

// Styles

const DisclaimerContainerStyled = styled.ul({
  margin: '1rem 1rem 1rem -1rem',
})

const DisclaimerStyled = styled.li({
  fontSize: '1.2rem',
})
